import { Menu } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { AlfredTableColumn } from 'components/organisms/AlfredTable';
import { CustomProjectModel, ProjectType } from 'core/domain/project/model/projectModel';
import ContextualMenu from 'components/atoms/ContextualMenu';
import { projectTypeTranslationManager } from 'utils/projects';
import { Icon } from 'components/atoms/Icons';
import './styles.scss';

interface Props {
  translations: Record<string, string>;
  onOpenDeleteProjectModal: (id: string) => void;
  isUserSuperAdmin: boolean;
}

export const ProjectsColumns = ({
  translations,
  onOpenDeleteProjectModal,
  isUserSuperAdmin,
}: Props): AlfredTableColumn<CustomProjectModel>[] => {
  const {
    nameTitle,
    typeTitle,
    supportEmailTitle,
    actionsTitle,
    actionsDeleteProjectButtonText,
    notReportedText,
  } = translations;
  return [
    {
      title: nameTitle,
      key: 'name',
      width: '40%',
      render: (text, { logo, name }) => (
        <span>
          <img className={'ProjectsListColumns__wrapper'} src={logo} alt={name} />
          {name}
        </span>
      ),
    },
    {
      title: typeTitle,
      key: 'type',
      width: '20%',
      render: (text, { type }) => projectTypeTranslationManager[type as ProjectType]
    },
    {
      title: supportEmailTitle,
      key: 'supportEmail',
      width: '30%',
      dataIndex: 'supportEmail',
      render: (text, { supportEmail }) => {
        return !!supportEmail.length
          ? <span>{supportEmail}</span>
          : <span className={'ProjectsListColumns__notReported'}>{notReportedText}</span>
      },
    },
    {
      title: actionsTitle,
      key: 'actions',
      width: '10%',
      render: (text, { id }) => {
        const menuItems: ItemType[] = [
          isUserSuperAdmin ? {
            key: 'deleteProject',
            label: actionsDeleteProjectButtonText,
            onClick: () => onOpenDeleteProjectModal(id),
            danger: true,
          } : null,
        ].filter(Boolean);
        return (
          <div key={id} onClick={(event) => event.stopPropagation()}>
            {!!menuItems.length ? (
              <ContextualMenu menu={<Menu items={menuItems} />} />
            ) : (
              <Icon.Elipsis className={'ProjectsListColumns__disabled'} />
            )}
          </div>
        )
      },
    },
  ];
};
